import { defineMessages } from 'react-intl'

export default defineMessages({
  defaultTitle: {
    id: 'components.MemoryListBlock.defaultTitle',
    defaultMessage: 'Pronunciations',
  },
  playTitle: {
    id: 'components.MemoryListBlock.playTitle',
    defaultMessage: 'Play',
  },
  stopTitle: {
    id: 'components.MemoryListBlock.stopTitle',
    defaultMessage: 'Stop',
  },
  downloadAudioTitle: {
    id: 'components.MemoryListBlock.downloadAudioTitle',
    defaultMessage: 'Download audio',
  },
  recordTitle: {
    id: 'components.MemoryListBlock.recordTitle',
    defaultMessage: 'Record',
  },
  deleteTitle: {
    id: 'components.MemoryListBlock.deleteTitle',
    defaultMessage: 'Delete',
  },
})
